module.exports = "/assets/data/5ce00dd79298733ec3092a7e3448b262-EN11.data.json";